import Axios from 'axios'

export default async function createEZClaim(loadNumber, reasonValue, description, referenceNumber, accessToken) {
  const Auth = {Authorization: `Bearer ${accessToken}`}
  return await Axios.post('/backend/create_ez_claim', {loadNumber, reasonValue, accessToken, description, referenceNumber},{headers: Auth})
}